import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { EventName, EventService } from '@accesso/cc-std-lib';

import { getNormalizedRoute } from './routing.utils';

@Injectable({
	providedIn: 'root',
})
export class PageViewTrackerService {
	constructor() {
		if (isPlatformServer(inject(PLATFORM_ID))) {
			return;
		}

		const router = inject(Router);
		const eventService = inject(EventService);

		router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
			const url = event.urlAfterRedirects;
			const normalizedUrl = '/' + getNormalizedRoute(router.routerState.snapshot.root);
			const { queryParams: query } = router.routerState.snapshot.root;

			eventService.publish({
				event: EventName.PAGE_VIEW,
				details: {
					url,
					normalizedUrl,
					data: {
						query,
					},
				},
			});
		});
	}
}
